import store from "../../store";
const downloadTableData = async ({ commit }, data) => {
  try {
    if (data.tableName === "users") {
      await store.dispatch("downloadUsersXls", data);
    }

    if (data.tableName === "payments") {
      await store.dispatch("downloadPaymentsXls", data);
    }

    if (data.tableName === "userCommisions") {
      await store.dispatch("downloadUserCommisionsXls");
    }

    if (data.tableName === "ordersHistory") {
      await store.dispatch("downloadOrdersHistoryXls", data);
    }

    if (data.tableName === "notFoundOrders") {
      await store.dispatch("downloadNotFoundOrdersHistoryXls");
    }

    commit("SET_DOWNLOAD_MESSAGE", "OK");
    return true;
  } catch (error) {
    return false;
  }
};

export default {
  downloadTableData,
};
